import { FormSubmission, EvidenceCategoryKey, EvidenceItem } from '../types';
import styles from '../form-submissions.module.css';
import { FileCheck, Award, TrendingUp, Calendar } from 'lucide-react';

interface StatsGridProps {
  submission: FormSubmission;
}

export function StatsGrid({ submission }: StatsGridProps) {
  const { evidence, immigration } = submission;

  // Count total evidence items
  const totalEvidenceCount = Object.values(evidence).reduce(
    (sum: number, items: EvidenceItem[]) => sum + items.length,
    0
  );

  // Count criteria met (categories with at least one item)
  const criteriaMet = (Object.keys(evidence) as EvidenceCategoryKey[]).filter(
    key => evidence[key].length > 0
  ).length;

  // Calculate days until visa expiry
  const getDaysUntilExpiry = () => {
    if (!immigration.visaExpiryDate) return null;
    const expiry = new Date(immigration.visaExpiryDate);
    const today = new Date();
    const diffTime = expiry.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const daysUntilExpiry = getDaysUntilExpiry();

  return (
    <div className={styles.statsGrid}>
      <div className={styles.statCard}>
        <div className={styles.statValue}>{totalEvidenceCount}</div>
        <div className={styles.statLabel}>
          <FileCheck size={14} style={{ marginRight: '6px' }} />
          Evidence Items
        </div>
      </div>

      <div className={styles.statCard}>
        <div className={styles.statValue}>{criteriaMet}/8</div>
        <div className={styles.statLabel}>
          <Award size={14} style={{ marginRight: '6px' }} />
          Criteria Met
        </div>
      </div>

      <div className={styles.statCard}>
        <div className={styles.statValue}>{Math.round((criteriaMet / 8) * 100)}%</div>
        <div className={styles.statLabel}>
          <TrendingUp size={14} style={{ marginRight: '6px' }} />
          Profile Strength
        </div>
      </div>

      {daysUntilExpiry !== null && (
        <div className={styles.statCard}>
          <div
            className={styles.statValue}
            style={{
              color:
                daysUntilExpiry < 90 ? '#eb3424' : daysUntilExpiry < 180 ? '#b8860b' : undefined,
            }}
          >
            {daysUntilExpiry}
          </div>
          <div className={styles.statLabel}>
            <Calendar size={14} style={{ marginRight: '6px' }} />
            Days to Expiry
          </div>
        </div>
      )}
    </div>
  );
}
